export default "__VITE_ASSET__aevpE$Gh__"